'use client'

import { PaginationProviderProps } from '../types/Pagination'
import React, { useMemo, createContext, useContext, useState, useEffect } from 'react'
import { FilterContext } from './filter-provider'
import { SortingContext } from './SortingProvider'
import { PaginationParams, PaginationProviderModel } from '../components'

export const PaginationContext = createContext<PaginationProviderModel>({} as PaginationProviderModel)

export const PaginationProvider = ({
    children,
    offset = 0,
    limit = 25,
    total = 0,
    initialPage = 1,
}: PaginationProviderProps) => {
    const filterContext = useContext(FilterContext)
    const sortingContext = useContext(SortingContext)

    const [params, setParams] = useState<PaginationParams>({ offset, limit })
    const [totalResults, setTotalResults] = useState<number>(total)
    const [currentPage, setCurrentPage] = useState<number>(initialPage)

    const paginateHandler = (offset: number, limit: number): void => {
        const sameConfig: boolean = params.offset === offset && params.limit === limit
        if (sameConfig) return
        setParams({ offset, limit })
    }

    const resetPagination = () => {
        paginateHandler(0, limit)
        setCurrentPage(1)
    }

    useEffect(() => {
        if (filterContext) resetPagination()
    }, [filterContext?.filters])

    useEffect(() => {
        if (sortingContext) resetPagination()
    }, [sortingContext?.sorting])

    const PaginationProviderData: PaginationProviderModel = useMemo(
        () => ({
            params,
            totalResults,
            setTotalResults,
            paginateHandler,
            initialPage,
            resetPagination,
            currentPage,
            setCurrentPage,
        }),
        [params, totalResults, initialPage, currentPage],
    )

    return <PaginationContext.Provider value={PaginationProviderData}>{children}</PaginationContext.Provider>
}
